<template>
  <div class="index" v-cloak>
    
    <div class="wrapper">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">{{school}}</div>
          <div class="name line1">{{name}}</div>
          <div class="line1"></div>
        </div>
      </div>
      
      <div class="title acea-row row-between-wrapper">
      <van-button type="default" @click="goCodeList" class="buttonViewUser">推荐二维码列表</van-button>
      <van-button type="default" @click="goBuyList" class="buttonViewUser">商品购买记录</van-button>
      <van-button type="default" @click="goCancelBind" class="buttonViewUser">解除微信绑定</van-button>
      </div>
      
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import SYCodeList from "@components/SYCodeList";
import { getCodeList } from "@api/public";
import cookie from "@utils/store/cookie";
import { openShareAppMessage, openShareTimeline, ready } from "@libs/wechat";
import { isWeixin } from "@utils/index";

import { Button} from 'vant';
import { Toast } from 'vant';

const HAS_COUPON_WINDOW = "has_coupon_window";

export default {
  name: "user",
  components: {
    [Button.name]:Button,
    [Toast.name]:Toast,
    swiper,
    swiperSlide,
    SYCodeList
  },
  props: {},
  data: function() {
    return {
      school:"",
      name:"",
      resData:[],
    };
  },
  mounted: function() {
    let that = this;
    that.school = cookie.get("lishu-school");
    that.name = cookie.get("lishu-name");
    that.haveInfo = cookie.get("lishu-haveInfo");

    if (that.name != "") {
      that.name = that.name+"老师";
    }


    // let openid = cookie.get("lishu-openid");
    // console.log("mounted ----- ");

    // if (openid) {
    //   getCodeList(1, 100, openid).then(data => {
    //   console.log(data);
    //   if (data.code == 0) {
    //     that.$set(that, "resData", data.data);
    //     console.log("resData");
    //   }else if (data.code == 301){
    //     this.$router.push({
    //         path: "/user/binding"
    //     });
    //   }
    //   console.log(that.resData);
    //   });
    // }
  },
  methods: {
    goCodeList() {
      console.log("goCodeList");
      let that = this;

      that.$router.push({
        path: "/codeList"
      });
    },
    goBuyList() {
      console.log("goBuyList");
      let that = this;

      that.$router.push({
        path: "/buyProductList"
      });
    },
    goCancelBind() {
      console.log("goCancelBind");
      let that = this;

      if (that.haveInfo == "1") {
          that.$router.push({
            path: "/user/cancelBinding"
          });
      }else{
        Toast("未绑定个人信息");
      }

    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    setOpenShare: function() {
      getShare().then(res => {
        var data = res.data.data;
        var configAppMessage = {
          desc: data.synopsis,
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        var configTimeline = {
          title: data.title,
          link: location.href,
          imgUrl: data.img
        };
        if (isWeixin() === true) {
          ready().then(() => {
            openShareAppMessage(configAppMessage).then(() => {});
            openShareTimeline(configTimeline).then(() => {});
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.buttonViewUser {
  margin-top: 10px; 
  width: 100%;
}
.index {
  background-color: #fff;
}
.noData {
  font-size: 20px;
  color: #888888;
  margin:0 auto;
  margin-top: 50%;
}

.syTitle {
  background-color: #e93323;
  color: #fff;
  font-size: 20px;
}
</style>
